/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Reset_Password_QuestionInputs */

const en_mobile_faq_reset_password_question = /** @type {(inputs: Mobile_Faq_Reset_Password_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset your password`)
};

const es_mobile_faq_reset_password_question = /** @type {(inputs: Mobile_Faq_Reset_Password_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer tu contraseña`)
};

/**
* | output |
* | --- |
* | "Reset your password" |
*
* @param {Mobile_Faq_Reset_Password_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_reset_password_question = /** @type {((inputs?: Mobile_Faq_Reset_Password_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Reset_Password_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_reset_password_question(inputs)
	return en_mobile_faq_reset_password_question(inputs)
});